<template>
  <div class="search-form">
    <b-row class="mt-3">
      <div class="d-flex ml-3 pt_6">
        <div class="side-frame"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('table_predict_sku_header_title') || '产品推广计划' }}
          </span>
          <el-divider direction="vertical"></el-divider>
        </div>
      </div>
      <b-col cols="7" style="padding-left: 0px;">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const initForm = { keyword: '' }
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}

.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.pt_6 {
  padding-top: 6px;
}
</style>
